module.exports = __webpack_public_path__ + "static/media/miq-sync-arrow.5646cb87.svg";